import { gql } from '@apollo/client';

export const LIST_ORGANISATIONS = gql`
  query listOrganisations($limit: Int, $nextToken: String) {
    listOrganisations(limit: $limit, nextToken: $nextToken) {
      items {
        pers_provider
        pers_region
        village_operator
        village_name
        care_provider
        care_provider_region
      }
      nextToken
    }
  }
`;
